import { render, staticRenderFns } from "./ProcessApprovalCard.vue?vue&type=template&id=6cd3af23"
import script from "./ProcessApprovalCard.vue?vue&type=script&lang=js"
export * from "./ProcessApprovalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports